/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import React from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {LandingHeader} from './LandingHeader'
import {LandingTopBar} from './LandingTopBar'

export function LandingHeaderWrapper() {
  const {config, classes, attributes} = useLayout()
  const {header, aside} = config
  console.log('wssa', attributes)
  return (
    <div
      id='kt_landing_header'
      className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
      {...attributes.headerMenu}
    >
      <div
        className={clsx(
          classes.headerContainer.join(' '),
          'd-flex align-items-stretch justify-content-between'
        )}
      >
        <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 w-lg-225px me-5'>
          <Link to='/job'>
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/logos/logo.png')}
              className='d-none d-lg-inline h-40px'
            />
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/logos/logo.png')}
              className='d-lg-none h-30px'
            />
          </Link>
        </div>

        <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
          <div className='d-flex align-items-stretch'>
            <div className='d-flex align-items-stretch' id='kt_landing_header_nav'>
              <LandingHeader />
            </div>
          </div>

          <LandingTopBar />
        </div>
      </div>
    </div>
  )
}
